import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { wati_DOMAIN } from "../constants";

const WatiSocketContext = createContext();

export const useWatiSocket = () => {
  const context = useContext(WatiSocketContext);
  if (!context) {
    throw new Error('useWatiSocket must be used within a WatiSocketProvider');
  }
  return context;
};

export const WatiSocketProvider = ({ children }) => {
  const [watiChatUpdates, setWatiChatUpdates] = useState([]);
  const [isWatiConnected, setIsWatiConnected] = useState(false);

  useEffect(() => {
    const socket = io(wati_DOMAIN, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionDelay: 2000,
    });

    socket.on("connect", () => {
      setIsWatiConnected(true);
    });

    socket.on("disconnect", () => {
      setIsWatiConnected(false);
    });

    socket.on("connect_error", () => {
      setIsWatiConnected(false);
    });

    socket.on("chatUpdate", (data) => {
      setWatiChatUpdates((prev) => [...prev, data]);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <WatiSocketContext.Provider value={{ watiChatUpdates, setWatiChatUpdates, isWatiConnected }}>
      {children}
    </WatiSocketContext.Provider>
  );
};
